<template>
    <div v-cloak id="searchWidgetMobile"  style="width:calc(34%)!important">
        <div class="search-trigger bg-gray-900" :class="{highlighted: open > 0}">
            <a href="#" @click.prevent="openSearch()"><i class="fas fa-search" aria-hidden="true"></i> Search</a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: 0
            }
        },
        methods: {
            openSearch: function () {
                eventBus.$emit('slideover-open-search');
            }
        },
        mounted() {
            var that = this;
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/setup';

    #searchWidgetMobile {
        z-index: 5;
        position: relative;

        @include grid-media($mobileMenu) {
            display:inline-block;
            margin-right: 0.5em;
        }

        float: none;
        margin-right: 0;


        div.search-trigger {
            padding: 0.4em 1em;
            font-size: 12px;
            a {
                display: block;
                color: #FFF;
                text-decoration: none;
                .fas {
                    margin-right: 5px;
                }
                &:hover {
                    color: $yellow;
                }
            }

            @include mobile() {
                padding: 10px 1em 4px;
                background-color: $brand;
                text-align: center;
                font-size: 12px;

                a .fas {
                    display: block;
                    margin: 0.1em auto;
                    height: 20px;
                    font-size: 16px;
                }
                &.highlighted a{
                    color:$yellow;
                }
            }

            @include grid-media($mobileMenu) {
                border-radius: $standardBorderRadius $standardBorderRadius 0 0;

                a {
                    display: inline;
                }
            }
        }
    }

    .widget-badge{
        background-color: $yellow;
        border-radius: 50%;
        padding: 0.3em 0.5em 0.4em 0.44em;
        font-size: 9px;
        color: #000;
        font-weight: 700;
        margin-left: 7px;
        display: inline-block;
        width: 20px;
        text-align: center;
        @include mobile(){
            float: right;
            margin-top: -45px;
        }
    }
    [v-cloak] {
        display: none;
    }
</style>
